export default "__VITE_ASSET__DS40YWfC__"